import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Navigation} from 'swiper/modules';
import blogData from '../../../data/blog-data';

const BlogTwo = () => {
    const blogItem = blogData;
    const slideControl = {
        spaceBetween: 25,
        speed: 1000,
        loop: true,
        slidesPerView: 3,
        autoplay: {
            delay: 4000,
            reverseDirection: false,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.blog_next',
            prevEl: '.blog_prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            },
        },
    };
    return (
        <div className="blog__two section-padding-two">
            <div className="container">
                <div className="row al-end mb-55">
                    <div className="col-lg-8">
                        <div className="blog__two-title lg-t-center lg-mb-20">
                            <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">PROJELER</span>
                            <h2 className="wow fadeInRight" data-wow-delay=".6s" style={{fontSize: "36px"}}>Öne Çıkan Projeler</h2>
                        </div>					
                    </div>
                    <div className="col-lg-4 wow fadeInDown" data-wow-delay=".4s">
                        <div className="slider-arrow jc-end lg-jc-center mb-10">
                            <div className="slider-arrow-prev blog_prev">
                            <i class="fa-regular fa-angle-left"></i>
                            </div>
                            <div className="slider-arrow-next blog_next">
                            <i class="fa-regular fa-angle-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row wow fadeInUp" data-wow-delay=".5s">
                    <div className="col-xl-12">
                        <Swiper modules={[EffectFade, Autoplay, Navigation]} {...slideControl} >
                            {blogItem?.map((data, id) => (
                                <SwiperSlide key={id}>
                                    <div className="blog__one-item">
                                        <div className="blog__one-item-image">
                                        <Link to={`/blog/${data.id}`}><img src={data.image} alt="blog" /></Link>
                                        </div>
{/*
<div className="blog__one-item-content t-center">
<h4 className='businessTitle'>{data.title}</h4>
</div>
*/}
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogTwo;